import type { SdkMixin } from '@wix/lean-components-infra';
import type { ValidationSchema } from '@wix/editor-elements-corvid-utils';
import {
  composeSDKFactories,
  withValidation,
} from '@wix/editor-elements-corvid-utils';
import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import { createLeanComponentSDK } from '@wix/lean-components-infra/runtime/sdk';
import type { CorvidSDKPropsFactory } from '@wix/editor-elements-types/corvid';
import type { IWutAvatarProps } from '../WutAvatar.props';

const sdkSchema = {
  firstName: {
    type: 'string',
  },
  lastName: {
    type: 'string',
  },
  src: {
    type: 'string',
  },
};

const validationSchema: ValidationSchema = {
  type: ['object'],
  properties: {
    firstName: {
      maxLength: 120,
      type: ['string', 'nil'],
    },
    lastName: {
      maxLength: 120,
      type: ['string', 'nil'],
    },
    size: {
      minimum: 10,
      maximum: 200,
      type: ['number'],
    },
    src: {
      maxLength: 1200,
      type: ['string', 'nil'],
    },
  },
};

const mixins = ['changeable'] as Array<SdkMixin>;

const stylesValidationSchema: ValidationSchema = {
  type: ['object'],
  properties: {
    size: {
      minimum: 10,
      maximum: 200,
      type: ['number'],
    },
  },
};

const stylesSDK: CorvidSDKPropsFactory<IWutAvatarProps, any> = api => {
  const { createSdkState, setStyles } = api;
  const [state, setState] = createSdkState({ size: undefined }, 'avatar');

  return {
    get size() {
      return state.size;
    },
    set size(value) {
      setState({ size: value });
      setStyles({
        '--corvid-circleSize': `${value}px`,
      });
    },
  };
};

export const sdk = composeSDKFactories([
  createLeanComponentSDK<IWutAvatarProps>({
    sdkSchema,
    validationSchema,
    mixins,
  }),
  withValidation(stylesSDK, stylesValidationSchema),
]);

export default createComponentSDKModel(sdk);
